import { NextPage } from 'next'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { ArticleSummary, summarizeArticles } from 'services/ContentfulService/models/articles'
import { NamedPromises } from 'lib'
import { fetchArticles } from 'services/ContentfulService/hooks/articles'
import { FeaturedConstraint, ProductConstraint } from 'services/ContentfulService/constraints'
import { ContentfulHookProps } from 'services/ContentfulService/hooks/template'
import { ContentfulProducts } from 'parameters/products'
import { ToolPageTemplate } from 'experiences/Calculators/pages/ToolPage'
import { usePageAsset, usePageRichTextResource, usePageTextResource } from '../../stores/Contentful/hooks'
import { ApprovabilityWidget } from 'experiences/Calculators/Approvability'
import { BasicRichText } from 'components/vendor/Contentful/richText/RichTextRenderer'
import { ApprovabilityDataContainer } from 'experiences/Calculators/Approvability/store'

interface Props {
	articles: ArticleSummary[]
}

const Resources = {
	title: 'title',
	heroText: 'hero-text',
	graphic: 'graphic'
}

const ApprovabilityToolPage: NextPage<PagePropsWrapper<Props>> = ({ metaTags, pageProps }) => {
	const title = usePageTextResource(Resources.title)
	const description = usePageRichTextResource(Resources.heroText)
	const graphic = usePageAsset(Resources.graphic)
	return (
		<StandardLayout metaTags={metaTags}>
			<ToolPageTemplate
				articles={pageProps?.articles}
				title={title}
				introduction={<BasicRichText document={description} />}
				graphic={graphic}
			>
				<ApprovabilityDataContainer>
					<ApprovabilityWidget mode="contextual" />
				</ApprovabilityDataContainer>
			</ToolPageTemplate>
		</StandardLayout>
	)
}

const articlesInput: ContentfulHookProps = {
	constraints: [ProductConstraint(ContentfulProducts.Loans), FeaturedConstraint()],
	count: 4
}

export const getServerSideProps = getSEOServersideProps<Props>(async () => {
	return await NamedPromises({
		articles: fetchArticles(articlesInput).then(summarizeArticles)
	})
})

export default ApprovabilityToolPage
